import { ArrowLeftColor } from "@components";
import { PATH_HOME } from "@configs";
import { IMemberTier } from "@interfaces";
import { selectMerchant } from "@redux";
import { RenderMeta } from "@utils";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import styled from "styled-components";

interface IProps {
    socials: JSX.Element[];
    avatar: string;
    fullName: string;
    memberTier: IMemberTier | undefined;
    isConfirm?: boolean;
}

export const ComponentSocialMediaPage = (props: IProps) => {
    //page props
    const { socials } = props;
    const { t } = useTranslation();
    const merchant = useSelector(selectMerchant);
    const history = useHistory();
    const { themes } = useSelector(selectMerchant);

    const [menuTab, setMenuTab] = useState<number>(0);
    const onChange = (key: string | string[]) => {
        //
    };

    return (
        <>
            <RenderMeta title={t("meta.socialmedia_page")} />
            <StlyedSocialMedia themeColor={themes?.themeColor!}>
                <div className="back-arrow">
                    <ArrowLeftColor
                        color={themes?.themeColor}
                        onClick={() => history.push(PATH_HOME)}
                    />
                    {/* <span>{t("page.back")}</span> */}
                </div>
                <div className="img-banner">
                    <span>
                        <img src="../images/img-socia-media-new.png" alt="" />
                    </span>
                </div>
                <div className="layout-content">
                    <div className="top-content">
                        WINNERS ANNOUNCED ON <span>02/17</span>
                    </div>
                    <div className="main-content">
                        <div className="tab-section">
                            <div
                                className={menuTab === 0 ? "menu-active" : ""}
                                onClick={() => setMenuTab(0)}
                            >
                                Information
                            </div>
                            <div
                                className={menuTab === 1 ? "menu-active" : ""}
                                onClick={() => setMenuTab(1)}
                            >
                                Hashtag Social
                            </div>
                        </div>

                        {menuTab === 0 && (
                            <>
                                <div className="box-content">
                                    <div className="title-content">
                                        Campaign The Store Make Up challenge!
                                    </div>
                                    <p>Participate in our make up contest and win a stylish...</p>
                                </div>
                                <div className="box-content">
                                    <div className="herehow-title">HERE’S HOW :</div>
                                    <ol>
                                        <li>Take a picture using our photo frame</li>
                                        <li>Keep your picture on instagram for at least 15 days</li>
                                        <li>
                                            Use the{" "}
                                            <span className="hashtag">#TheStorecampaign</span>{" "}
                                            hashtag
                                        </li>
                                    </ol>
                                </div>
                            </>
                        )}
                        {menuTab === 1 && (
                            <>
                                <div className="wrapper-hashtagsocial">
                                    <div className="layout-hashtagsocial">
                                        <div className="img-hashtagsocial">
                                            <span>
                                                <img src="../../images/img-hashtag-01.png" alt="" />
                                            </span>
                                            <div className="box-highlight">
                                                <img src="../../images/ic-highlight.png" alt="" />
                                            </div>
                                            <div className="box-ig">
                                                <img src="../../images/ic-ig.png" alt="" />
                                            </div>
                                        </div>
                                        <div className="detail-hashtagsocial">
                                            <h2>Korean Make Up!</h2>
                                            <h3>#TheStorecampaign</h3>
                                            <div className="profile-hashtagsocial">
                                                <div className="img-profile-hashtagsocial">
                                                    <img
                                                        src="../../images/img-profile-social.png"
                                                        alt=""
                                                    />
                                                </div>
                                                Pachari P.
                                                <span>1241</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="layout-hashtagsocial">
                                        <div className="img-hashtagsocial">
                                            <span>
                                                <img src="../../images/img-hashtag-02.png" alt="" />
                                            </span>
                                            <div className="box-highlight">
                                                <img src="../../images/ic-highlight.png" alt="" />
                                            </div>
                                            <div className="box-ig">
                                                <img src="../../images/ic-ig.png" alt="" />
                                            </div>
                                        </div>
                                        <div className="detail-hashtagsocial">
                                            <h2>Trendy Make Up</h2>
                                            <h3>#TheStorecampaign</h3>
                                            <div className="profile-hashtagsocial">
                                                <div className="img-profile-hashtagsocial">
                                                    <img
                                                        src="../../images/img-profile-social.png"
                                                        alt=""
                                                    />
                                                </div>
                                                Pachari P.
                                                <span>1241</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="layout-hashtagsocial">
                                        <div className="img-hashtagsocial">
                                            <span>
                                                <img src="../../images/img-hashtag-02.png" alt="" />
                                            </span>
                                            {/* <div className="box-highlight">
                                            <img src="../../images/ic-highlight.png" alt="" />
                                        </div> */}
                                            <div className="box-ig">
                                                <img src="../../images/ic-ig.png" alt="" />
                                            </div>
                                        </div>
                                        <div className="detail-hashtagsocial">
                                            <h2>Trendy Make Up</h2>
                                            <h3>#TheStorecampaign</h3>
                                            <div className="profile-hashtagsocial">
                                                <div className="img-profile-hashtagsocial">
                                                    <img
                                                        src="../../images/img-profile-social.png"
                                                        alt=""
                                                    />
                                                </div>
                                                Pachari P.
                                                <span>1241</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="layout-hashtagsocial">
                                        <div className="img-hashtagsocial">
                                            <span>
                                                <img src="../../images/img-hashtag-01.png" alt="" />
                                            </span>
                                            {/* <div className="box-highlight">
                                            <img src="../../images/ic-highlight.png" alt="" />
                                        </div> */}
                                            <div className="box-ig">
                                                <img src="../../images/ic-ig.png" alt="" />
                                            </div>
                                        </div>
                                        <div className="detail-hashtagsocial">
                                            <h2>Korean Make Up!</h2>
                                            <h3>#TheStorecampaign</h3>
                                            <div className="profile-hashtagsocial">
                                                <div className="img-profile-hashtagsocial">
                                                    <img
                                                        src="../../images/img-profile-social.png"
                                                        alt=""
                                                    />
                                                </div>
                                                Pachari P.
                                                <span>1241</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
                <div className="btn-page">
                    <StyledUsedBtn
                        className="btn-redeem"
                        themeColor={themes?.themeColor!}
                        // onClick={() => setOpenText(false)}
                    >
                        Connect Instagram Account
                    </StyledUsedBtn>
                </div>
            </StlyedSocialMedia>
        </>
    );
};

const StlyedSocialMedia = styled.div<{ themeColor: string }>`
    width: 100%;
    margin: 0 auto;
    height: 100vh;
    background-color: #fff;
    background-position: right top;
    background-repeat: no-repeat;
    position: relative;
    .btn-page {
        margin: 16px 0;
        position: fixed;
        bottom: 16px;
        left: 16px;
        width: calc(100% - 32px);
    }
    .layout-content {
        position: relative;
        margin-top: -50px;
        border-top-right-radius: 16px;
        border-top-left-radius: 16px;
        background-color: #fff;
        padding: 50px 16px;
        overflow: hidden;
        .top-content {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            padding: 10px 0;
            background-color: #f7e0e5;
            font-size: 12px;
            font-weight: 500;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #2f2b2c;
            span {
                color: #c94370;
                margin-left: 10px;
            }
        }
        .main-content {
            .wrapper-hashtagsocial {
                margin-top: 20px;
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 10px;
                padding-bottom: 50px;
                .layout-hashtagsocial {
                    position: relative;
                    marign-bottom: 10px;
                    .img-hashtagsocial {
                        position: relative;
                        width: 100%;
                        padding-top: 125%;
                        margin-bottom: 10px;
                        span {
                            position: absolute;
                            top: 0;
                            right: 0;
                            bottom: 0;
                            left: 0;
                            img {
                                width: 100%;
                                height: 100%;
                                object-fit: cover;
                            }
                        }
                        .box-highlight {
                            position: absolute;
                            left: 10px;
                            top: 10px;
                            img {
                                max-width: 100%;
                            }
                        }
                        .box-ig {
                            position: absolute;
                            right: 10px;
                            bottom: 10px;
                            img {
                                max-width: 100%;
                            }
                        }
                    }
                    .detail-hashtagsocial {
                        h2 {
                            font-size: 14px;
                            font-weight: 600;
                            color: #000;
                            margin-bottom: 5px;
                        }
                        h3 {
                            font-size: 12px;
                            color: #9b9b9b;
                            margin-bottom: 5px;
                        }
                        .profile-hashtagsocial {
                            position: relative;
                            padding-left: 20px;
                            font-size: 12px;
                            font-weight: 600;
                            color: #000;
                            .img-profile-hashtagsocial {
                                position: absolute;
                                top: 50%;
                                left: 0;
                                transform: translateY(-50%);
                                img {
                                    width: 16px;
                                }
                            }
                            span {
                                float: right;
                                background-image: url(../../images/ic-heart.png);
                                color: #9b9b9b;
                                padding-left: 15px;
                                background-repeat: no-repeat;
                                background-position: left center;
                            }
                        }
                    }
                }
            }
            .tab-section {
                display: flex;
                justify-content: flex-start;
                grid-gap: 30px;
                color: ${(p) => p.themeColor};
                color: #9daaae;
                font-size: 16px;
                font-weight: 500;
                cursor: pointer;
                padding-bottom: 8px;
                .menu-active {
                    // border-bottom: 2px solid ${(p) => p.themeColor};
                    // color: ${(p) => p.themeColor};
                    color: #000;
                    font-weight: 600;
                    position: relative;
                    &:after {
                        content: "";
                        position: absolute;
                        width: 20px;
                        height: 3px;
                        bottom: -8px;
                        left: 50%;
                        transform: translateX(-50%);
                        border-radius: 4px;
                        // background-color: ${(p) => p.themeColor};
                        background: linear-gradient(
                            342deg,
                            rgba(162, 26, 115, 1) 0%,
                            rgba(227, 62, 59, 1) 100%
                        );
                    }
                }
            }
            .box-content {
                border-bottom: 1px solid #e1e1e1;
                margin: 16px 0;
                &:last-child {
                    border: none;
                }
                .herehow-title {
                    background-image: url(../../images/hand.svg);
                    font-size: 14px;
                    font-weight: 600;
                    background-position: left center;
                    background-repeat: no-repeat;
                    padding-left: 30px;
                    margin-bottom: 10px;
                }
                .title-content {
                    font-size: 18px;
                    color: #000;
                    line-height: 21px;
                    font-weight: 600;
                    margin-bottom: 16px;
                }
                p {
                    font-size: 14px;
                    line-height: 20px;
                    color: #525257;
                    margin-bottom: 16px;
                }
                ol {
                    padding: 0;
                    list-style-position: inside;
                    li {
                        font-size: 14px;
                        color: #525257;
                        span.hashtag {
                            background-color: #fce6e9;
                            color: #f44237;
                        }
                    }
                }
            }
        }
    }
    .img-banner {
        width: 100%;
        position: relative;
        padding-top: 75%;
        z-index: 0;
        span {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
    }
    .back-arrow {
        position: absolute;
        left: 10px;
        top: 15px;
        display: flex;
        align-items: center;
        z-index: 1;
        span {
            margin-left: 10px;
            color: ${(p) => p.themeColor};
        }
    }
    .logo-survey {
        font-size: 32px;
        color: ${(p) => p.themeColor};
        font-weight: 600;
    }
    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px;
        .title-group {
            text-align: center;
        }
        h4 {
            flex: 1;
            display: flex;
            justify-content: center;
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 25px;
            color: #000000;
        }
    }
`;

const StyledUsedBtn = styled.button<{ themeColor: string }>`
    padding: 3px 12px;
    color: ${(p) => p.theme.colors.card};
    // background: ${(p) => p.themeColor};
    // border: 0.5px solid ${(p) => p.themeColor};
    border: none;
    background: linear-gradient(342deg, rgba(162, 26, 115, 1) 0%, rgba(227, 62, 59, 1) 100%);
    border-radius: 40px;
    cursor: pointer;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    height: 48px;
    width: 100%;
    &:active {
        opacity: 0.8;
    }
`;
